import { Component } from "@angular/core";
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/ngrx/reducers";
import {
  AuthenticationSelectors,
  SettingsSelectors,
} from "src/app/ngrx/selectors";
import { SettingsActions } from "src/app/ngrx/actions";
import { ChangeLanguageComponent } from "../change-language/change-language.component";

@Component({
  selector: "app-settings",
  imports: [ChangePasswordComponent, ChangeLanguageComponent],
  templateUrl: "./settings.component.html",
  styles: ``,
})
export class SettingsComponent {
  isChangingPassword = this.store.selectSignal(
    SettingsSelectors.isChangingPassword,
  );

  isChangingLanguage = this.store.selectSignal(
    SettingsSelectors.isChangingLanguage,
  );

  currentLanguage = this.store.selectSignal(
    AuthenticationSelectors.currentLanguage,
  );

  constructor(private readonly store: Store<AppState>) {}

  changePassword(event: { oldPassword: string; newPassword: string }) {
    this.store.dispatch(SettingsActions.changePassword(event));
  }

  changeLanguage({ language }: { language: string }) {
    this.store.dispatch(
      SettingsActions.changeLanguage({
        language: language,
      }),
    );
  }
}
